import SignIn from '../Login/Login.page';
import Register from '../Register/Register.page';
import Dashboard from '../Dashboard/Dashboard.page';
import Billing from '../Billing/Billing.page';
import PatientDocument from '../PatientDocument/PatientDocument.page';
import FormSubmission from '../FormSubmission/FormSubmission.page';
import ForgotPassword from '../Manage Password/ForgotPassword/ForgotPassword.page';
import SetNewPassword from '../Manage Password/SetNewPassword/SetNewPassword.page';
import ResetPassword from '../Manage Password/ResetPassword/ResetPassword.page';
import VerifyIdentity from '../VerifyIdentity/VerifyIdentity.page';

const Pages = {
  SignIn,
  ForgotPassword,
  SetNewPassword,
  ResetPassword,
  Register,
  Dashboard,
  Billing,
  PatientDocument,
  FormSubmission,
  VerifyIdentity
};

export default Pages;
